import { render, staticRenderFns } from "./AdminScripts.vue?vue&type=template&id=a3c8250e&scoped=true"
import script from "./AdminScripts.vue?vue&type=script&lang=js"
export * from "./AdminScripts.vue?vue&type=script&lang=js"
import style0 from "./AdminScripts.vue?vue&type=style&index=0&id=a3c8250e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c8250e",
  null
  
)

export default component.exports